import { goodTotalIncrease, goodTotalDecrease } from './good-total.dispath'

interface Storage {
  registered: Function[]
  register: (callback: any) => void
  _dataBlobs: any
  dataBlobs: any
  increment: (id: string | number) => void
  decrement: (id: string | number) => void
}

/**
 * 商品数据管理
 */
export const goodStorage: Storage = {
  registered: [],
  register(callback: any) {
    if (typeof callback === 'function') {
      this.registered.push(callback)
    }
  },
  _dataBlobs: (() => {
    const map = new Map()
    const _set = map.set
    map.set = (key: any, value: any) => {
      let bool
      if (map.has(key)) {
        bool = true
      }
      const tempMap = _set.apply(map, [key, value])
      bool && goodStorage.registered.forEach((cb: any) => cb(key))
      return tempMap
    }
    return map
  })(),
  set dataBlobs(map: any) {
    this._dataBlobs = map
  },
  get dataBlobs() {
    return this._dataBlobs
  },
  increment(id: string | number) {
    const { dataBlobs } = goodStorage
    const good = dataBlobs.get(id)
    if (good) {
      let buy_count = parseInt(good.buy_count) + 1
      dataBlobs.set(id, {
        ...good,
        buy_count,
      })
    }

    goodTotalIncrease()
  },
  decrement(id: string | number) {
    const { dataBlobs } = goodStorage
    const good = dataBlobs.get(id)
    if (good) {
      let buy_count = parseInt(good.buy_count) - 1
      if (buy_count < 0) {
        buy_count = 0
      }
      dataBlobs.set(id, {
        ...good,
        buy_count,
      })
    }
    goodTotalDecrease()
  },
}
